import React from 'react';
import { FaGraduationCap, FaCalendarAlt, FaAward } from 'react-icons/fa';
import DynamicCard from './dynamic/DynamicCard';
import { Education } from '../types';

interface EducationCardProps {
  education: Education;
  index?: number;
}

const EducationCard: React.FC<EducationCardProps> = ({ education, index = 0 }) => {
  return (
    <DynamicCard delay={index * 0.1} className="relative">
      <div className="flex items-start mb-4">
        <div className="flex-shrink-0 w-12 h-12 bg-primary-100 dark:bg-primary-900 rounded-lg flex items-center justify-center mr-4">
          <FaGraduationCap className="text-primary-600 dark:text-primary-400" size={20} />
        </div>
        <div className="flex-grow">
          <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-1">{education.degree}</h3>
          <p className="text-lg text-primary-600 dark:text-primary-400 font-semibold mb-1">{education.field}</p>
          <p className="text-gray-700 dark:text-gray-300 font-medium mb-2">{education.institution}</p>
          <div className="flex items-center text-gray-500 dark:text-gray-400 text-sm">
            <FaCalendarAlt className="mr-2" size={12} />
            <span>{education.year}</span>
          </div>
        </div>
      </div>

      <p className="text-gray-600 dark:text-gray-300 mb-4">{education.description}</p>

      {education.achievements && education.achievements.length > 0 && (
        <div className="pt-4 border-t border-gray-200 dark:border-gray-700">
          <h4 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-3 flex items-center">
            <FaAward className="mr-2 text-primary-600 dark:text-primary-400" size={14} />
            Achievements:
          </h4>
          <ul className="space-y-2">
            {education.achievements.map((achievement, idx) => (
              <li key={idx} className="flex items-start text-sm text-gray-600 dark:text-gray-300">
                <span className="text-primary-600 dark:text-primary-400 mr-2 mt-1">•</span>
                <span>{achievement}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </DynamicCard>
  );
};

export default EducationCard;
